/**
 * Records tab, /lms/records (plan docs/plans/lms-plan.md 7.4, 7.5, 10.4,
 * 10.5, section 13 tab 3; R16, R17, R18, R24; WP-41).
 *
 *   - Transcript: every completion the person holds, current and superseded,
 *     with course, version, completed on, expires on, score, kind, the
 *     certificate code and Download (TranscriptTable)
 *   - the Training log PDF button (TrainingLogButton, in the header)
 *   - External certificates: upload with title, issuer, issued on, expires on,
 *     credential id and the requirement it is offered against; pending until
 *     an admin accepts or rejects it; a rejected upload stays with the
 *     reviewer's note (ExternalCertsSection)
 *   - Competency sign-offs: the requests and the latest observation, and
 *     "Request a sign-off" (7.4 names the Records tab; SignoffsSection)
 *
 * A learner reads only their own records (G14): every read is a /me route.
 * LmsApp routes /lms/records to this file's DEFAULT export.
 */
import { useState } from 'react';
import PageHeader, { RefreshButton } from '../../../ui/PageHeader';
import { lmsPageCls } from '../../components/layout/page';
import { lmsTab } from '../config';
import { ExternalCertsSection } from './ExternalCertsSection';
import { SignoffsSection } from './SignoffsSection';
import { TrainingLogButton } from './TrainingLogButton';
import { TranscriptTable } from './TranscriptTable';

const TAB = lmsTab('records');

export function RecordsTab() {
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div className={lmsPageCls} data-testid="lms-records">
      <PageHeader
        title={TAB.title}
        icon={TAB.icon}
        subtitle={TAB.description}
        actions={
          <>
            <TrainingLogButton />
            <RefreshButton onClick={() => setReloadKey((k) => k + 1)} label="Refresh records" />
          </>
        }
      />
      <TranscriptTable reloadKey={reloadKey} />
      <ExternalCertsSection reloadKey={reloadKey} />
      <SignoffsSection reloadKey={reloadKey} />
    </div>
  );
}

export default RecordsTab;
